<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" ref="searchform">
						<el-form-item label="标题" prop="title">
							<el-input placeholder="标题" v-model="formInline.title"></el-input>
						</el-form-item>
						<el-form-item label="状态" prop="status">
							<el-select placeholder="状态" v-model="formInline.status">
								<el-option label="待处理" value="1"></el-option>
								<el-option label="已处理" value="2"></el-option>
								<el-option label="拒绝处理" value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button @click="seachFun" type="primary">{{ $t('device.inquire') }}</el-button>
							<el-button @click="resetFun" type="primary">{{ $t('device.reset') }}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-button @click="addUser" type="primary" v-if="$store.state.pageAction.indexOf('task.add')> -1">
					{{ $t('device.add') }}
				</el-button>
			</template>
			<el-table :data="appData" :default-sort="{prop: 'date', order: 'descending'}" border stripe
				style="width: 100%">
				<el-table-column label="ID" prop="id" width="60"></el-table-column>
				<el-table-column label="主题" prop="title"></el-table-column>
				<el-table-column label="内容">
					<template #default="scope">
						{{ truncateText(scope.row.content,  30) }}
					</template>
				</el-table-column>
				<el-table-column label="发起人" prop="create_name"></el-table-column>
				<el-table-column label="代办人" prop="receiver_name"></el-table-column>
				<el-table-column label="状态" prop="status_title"></el-table-column>
				<el-table-column label="截止时间" prop="end_at" width="160"></el-table-column>
				<el-table-column label="发送时间" prop="send_at" width="160"></el-table-column>
				<el-table-column label="创建时间" prop="create_at" width="160"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="280">
					<template #default="scope">
						<!-- <el-button @click="handleEdit(scope.row)" type="primary" size="small"
							v-if="$store.state.pageAction.indexOf('task.edit')> -1">{{ $t('task.edit') }}
						</el-button>
						<el-button @click="handleSend(scope.row)" type="info" size="small"
							v-if="scope.row.status==2&&$store.state.pageAction.indexOf('task.send')> -1">发送
						</el-button> -->
						<el-button @click="handleDelete(scope.row)" type="danger" size="small"
							v-if="scope.row.status<=2&&$store.state.pageAction.indexOf('task.delete')> -1">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50, 200]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" fixed="right"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>

			<el-dialog center title="添加/编辑" top="30vh" v-model="addPop" width="50%">
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<el-form-item label="主题" label-width="120px" prop="title">
						<el-input v-model="addForm.title"></el-input>
					</el-form-item>
					<el-form-item label="内容" label-width="120px" prop="content">
						<el-input type="textarea" :row="40" v-model="addForm.content"></el-input>
					</el-form-item>

					<el-form-item label="截止时间" label-width="120px" prop="end_at">
						<el-date-picker type="datetime" v-model="addForm.end_at" :disabled-date="disabledDate"
							value-format="YYYY-MM-DD HH:mm:ss" append-to-body clearable
							popper-class="custom-datepicker"></el-date-picker>
					</el-form-item>

					<div style="display: flex; gap: 20px;">
						<el-form-item label="代办人" label-width="120px" prop="client_id">
							<el-cascader :options="clientOpts" placeholder="组织"
								v-model="addForm.client_id"></el-cascader>
						</el-form-item>

						<el-form-item label="" label-width="80px" prop="role_id">
							<div style="display: flex; align-items: center; gap: 30px;">
								<el-select placeholder="角色" v-model="addForm.role_id">
									<el-option :key="item.value" :label="item.label" :value="item.value"
										v-for="item in roleOpts"></el-option>
								</el-select>
								<el-button type="primary" @click="handleAddGroup">添加</el-button>
							</div>
						</el-form-item>
					</div>
					<!-- 新增标签展示区域 -->
					<div style="margin-top: 20px;margin-left: 100px;">
						<span v-for="(group, index) in selectedGroups" :key="index" class="tag-item">
							{{ getClientLabel(index)  }} - {{ getRoleLabel(index)  }}
							<i class="el-icon-close" @click="handleRemoveGroup(index)">X</i>
						</span>
					</div>

				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="addPop = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
	import message from "../../model/task";
	import role from "../../model/role";
	import client from "../../model/client";

	export default {
		name: "user",
		data() {
			return {
				dialogFormVisible: false,
				formInline: {
					title: "",
					status: "",
					page: 1,
					size: 10
				},
				resetform: {
					uid: "",
					title: "",
					password: ""
				},
				listCount: 0,
				appData: [],
				addPop: false,
				addForm: {
					type: 1,
					title: "",
					end_at: "",
					content: "",
					receiver: []
				},
				selectedGroups: [],
				roleOpts: [],
				clientOpts: [],
				clientListOpts: [],
				rules: {
					title: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					content: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					end_at: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					client_id: [{
						required: false,
						message: this.$t('role.select_customer'),
						trigger: "blur"
					}],
					role_id: [{
						required: false,
						message: this.$t('role.select_group'),
						trigger: "blur"
					}]
				}
			};
		},
		async mounted() {
			await this.loadData();
			this.loadRole();
			this.loadClient();
		},
		methods: {
			truncateText(text, limit) {
				return text?.length > limit ? `${text.substr(0,  limit)}...` : text || '-';
			},
			// 添加组合
			handleAddGroup() {
				if (!this.addForm.client_id || !this.addForm.role_id) {
					this.$message.warning(' 请选择组织角色');
					return;
				}
				console.log('client_id:' + this.addForm.client_id);

				let client_id = this.addForm.client_id.pop();

				const newGroup = {
					client_id: client_id,
					client_name: this.clientListOpts.find(item => item.value === client_id)?.label,
					role_id: this.addForm.role_id,
					role_name: this.roleOpts.find(item => item.value === this.addForm.role_id)?.label
				};

				this.selectedGroups.push(newGroup);
				// 清空选择
				this.addForm.client_id = '';
				this.addForm.role_id = '';
			},
			handleRemoveGroup(index) {
				this.selectedGroups.splice(index, 1);
			},
			// 获取设备托管的显示文本
			getClientLabel(i) {
				//console.log(JSON.stringify(this.selectedGroups))
				return this.selectedGroups[i]?.client_name;
			},

			// 获取角色组的显示文本
			getRoleLabel(i) {
				return this.selectedGroups[i]?.role_name;
			},
			resetFun() {
				this.formInline.title = ''
				this.formInline.status = ''
				this.loadData()
			},
			async loadData() {
				const ret = await message.list(this.formInline)
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
				}
			},
			async loadRole() {
				const ret = await role.map({})
				if (ret.code === 200) {
					ret.data.forEach(v => {
						this.roleOpts.push({
							value: v.id,
							label: v.title
						})
					})
				}
			},
			async loadClient() {
				const ret = await client.list({});
				if (ret.code === 200) {
					ret.data.forEach(i => {
						let options = {
							value: i.id,
							label: i.name,
							children: []
						};
						this.clientListOpts.push({ //list
							value: i.id,
							label: i.name
						});

						if (i.children.length > 0) {
							this.clientOpts.push({
								value: i.id,
								label: i.name
							});
							i.children.forEach(v => {
								let opts = {
									value: v.id,
									label: v.name
								};
								this.clientListOpts.push({ //list
									value: v.id,
									label: v.name
								});

								if (v.children.length > 0) {
									options.children.push({
										value: v.id,
										label: v.name
									});
									opts.children = [];
									v.children.forEach(item => {
										let children = {
											value: item.id,
											label: item.name,
										};
										this.clientListOpts.push({ //list
											value: item.id,
											label: item.name
										});

										if (item.children.length > 0) {
											children.children = [];
											item.children.forEach(val => {
												children.children.push({
													value: val.id,
													label: val.name
												});
												this.clientListOpts.push({ //list
													value: val.id,
													label: val.name
												});
											})
										}
										opts.children.push(children);
									});
								}
								options.children.push(opts);
							});
						}
						this.clientOpts.push(options);
					});
				}
				console.log(JSON.stringify(this.clientOpts));
			},
			async handleSubmit() {
				this.$refs.addForm.validate(async valid => {
					if (valid) {
						const params = JSON.parse(JSON.stringify(this.addForm))
						params.receiver = JSON.stringify(this.selectedGroups)
						const ret = await message.save(params)
						if (ret.code === 200) {
							this.addPop = false
							this.$message.success(ret.message)
							this.loadData()
						} else {
							this.$message.warning(ret.message)
						}
					} else {
						return false;
					}
				});
			},
			async handleStatus(row) {
				const ret = await message.status({
					uid: row.uid,
					status: row.status == 1 ? 2 : 1
				})
				if (ret.code === 200) {
					this.$message.success(ret.message)
					this.loadData()
				} else {
					this.$message.warning(ret.message)
				}
			},
			seachFun() {
				this.loadData();
			},
			addUser() {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					this.addForm = {
						type: 1,
						title: "",
						expire_at: "",
						content: "",
						receiver: []
					}
				})
			},
			handleEdit(row) {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					let rowData = JSON.parse(JSON.stringify(row))
					this.addForm = rowData
					this.selectedGroups = JSON.parse(rowData.receiver);
				})
			},
			async handleSend(row) {
				this.$confirm('此操作将给所有发送人发送消息', '发送', {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.send({
							id: row.id
						});
						if (ret.code === 200) {
							this.$message.success('操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					})
			},
			async handleWithdraw(row) {
				this.$confirm('此操作将撤回已发送消息', '撤回', {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.withdraw({
							id: row.id
						});
						if (ret.code === 200) {
							this.$message.success('操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					});
			},
			async handleDelete(row) {
				this.$confirm(this.$t('device.delete_note'), this.$t('device.tip'), {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.delete({
							id: row.id
						});
						if (ret.code === 200) {
							this.$message.success('操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					});
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.card-header {
		display: flex;
		align-items: center;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.tag-item {
		background-color: #f0f0f0;
		padding: 5px 10px;
		margin-right: 10px;
		border-radius: 4px;
		display: inline-flex;
		align-items: center;
	}

	.tag-item .el-icon-close {
		margin-left: 8px;
		cursor: pointer;
		color: red;
	}

	.tag-item .el-icon-close:hover {
		color: #666;
	}
</style>